import { useRoute } from 'vue-router'

import { ROUTE_NAMES } from '@/router/constants'

import { getLandingClidFromCookies, updateLandingWidgetIdCookie } from './cookie-parser'

// Affiliate link attribution
// Affiliate link looks like a game page link with a clid
// So we save initial game and clid to a temp cookie and attribute all events with that
export const processLandingAttributes = (route: ReturnType<typeof useRoute>) => {
    let landingWidgetId = '',
        landingClid = ''
    if (typeof window !== 'undefined') {
        landingWidgetId = getLandingClidFromCookies(document.cookie) || ''
        landingClid = landingWidgetId.split(':')[0]

        // We only need to save the attributes (both in app and in the cookie) in case if it's a game page with clid
        // If the clid is different from the one we have in cookie, we update it
        if (
            route.query.clid &&
            route.params.game &&
            route.name === ROUTE_NAMES.GAME_PAGE &&
            landingClid !== route.query.clid
        ) {
            landingWidgetId = `${route.query.clid}:${route.params.game}`
            landingClid = route.query.clid as string
            updateLandingWidgetIdCookie(landingWidgetId)
        }
    }

    return { landingClid, landingWidgetId }
}
